import React from "react";
import "./HowToUseMyByk.scss";
import TrinTrinIcon from "../../images/trin-trin-mybyk.svg"
import GreenArrow from "../../images/green-arrow.svg";
import useCityContent from "../../hooks/useCityContent";




const HowToUseMyByk = () => {
  const { cityData } = useCityContent();
  return (
    <section className="how-use section-padding-lg">
      <div className="how-use__header section-header">
        <h2 className={cityData.city_name === "mysuru" ? "heading-trin" : ""}>
          {cityData.city_name === "mysuru" ? (
            <>
              How to use <span><img src={TrinTrinIcon} alt="" /></span>
            </>
          ) : (
            "How to use MYBYK"
          )}
        </h2>
      </div>
      <div className="container">
        <div className="how-use__content">
          {cityData.how_to_use.map((step, index) =>
            step.isArrow ? (
              <div className="how-use__content-arrow" key={index}>
                <figure>
                  <img src={GreenArrow} alt="green-arrow" loading="lazy" />
                </figure>
              </div>
            ) : (
              <div className="how-use__content-wrap" key={index}>
                <figure>
                  <img src={step.image} alt={step.alt} loading="lazy" />
                </figure>
                <h3>{step.title}</h3>
                <p >
                  {step.description}
                </p>
              </div>
            )
          )}
        </div>

      </div>
    </section>
  );
};

export default HowToUseMyByk;
